import React from 'react';
import { Link } from 'react-router-dom';
import DataTable from 'react-data-table-component';

interface NotificationItem {
    id: string;
    title: string;
    message: string;
    type: string;
    status: string;
    createdAt: string;
    readAt: string | null;
}

const Notifications = () => {
    const columns = [
        {
            name: 'Title',
            selector: (row: NotificationItem) => row.title,
            sortable: true,
            cell: (row: NotificationItem) => (
                <div>
                    <div className="fw-bold">{row.title}</div>
                    <small className="text-muted">{row.message}</small>
                </div>
            ),
        },
        {
            name: 'Type',
            selector: (row: NotificationItem) => row.type,
            sortable: true,
            cell: (row: NotificationItem) => (
                <span className={`badge bg-${
                    row.type === 'ALERT' ? 'danger' : 
                    row.type === 'WARNING' ? 'warning' : 
                    row.type === 'SUCCESS' ? 'success' : 'info'
                }`}>
                    {row.type}
                </span>
            ),
        },
        {
            name: 'Status',
            selector: (row: NotificationItem) => row.status,
            sortable: true,
            cell: (row: NotificationItem) => (
                <span className={`badge bg-${row.status === 'READ' ? 'secondary' : 'primary'}`}>
                    {row.status}
                </span>
            ),
        },
        {
            name: 'Created',
            selector: (row: NotificationItem) => row.createdAt,
            sortable: true,
        },
        {
            name: 'Read At',
            selector: (row: NotificationItem) => row.readAt || '-',
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row: NotificationItem) => (
                <div className="d-flex gap-2">
                    <button 
                        className="btn btn-sm btn-primary"
                        disabled={row.status === 'READ'}
                    >
                        <i className="fa fa-check me-2"></i>Mark as Read
                    </button>
                    <button className="btn btn-sm btn-outline-danger">
                        <i className="fa fa-trash me-2"></i>Delete
                    </button>
                </div>
            ),
        },
    ];

    const data = [
        {
            id: '1',
            title: 'New Loan Application',
            message: 'A new loan application has been submitted for review',
            type: 'ALERT',
            status: 'UNREAD',
            createdAt: '2024-02-21 10:30',
            readAt: null,
        },
        {
            id: '2',
            title: 'Document Verification Complete',
            message: 'All documents have been verified for application APP001',
            type: 'SUCCESS',
            status: 'READ',
            createdAt: '2024-02-21 09:15',
            readAt: '2024-02-21 09:20',
        },
        // Add more sample data as needed
    ];

    const notificationStats = [
        { title: 'Total Notifications', value: '24', icon: 'fa-bell', color: 'primary' },
        { title: 'Unread', value: '5', icon: 'fa-envelope', color: 'danger' },
        { title: 'Today', value: '12', icon: 'fa-clock', color: 'info' },
        { title: 'This Week', value: '45', icon: 'fa-calendar', color: 'success' },
    ];

    return (
        <div>
            <div className="page-toolbar px-xl-4 px-sm-2 px-0 py-3">
                <div className="container-fluid">
                    <div className="row g-3 mb-3 align-items-center">
                        <div className="col">
                            <ol className="breadcrumb bg-transparent mb-0">
                                <li className="breadcrumb-item"><Link className="text-secondary" to="/">Home</Link></li>
                                <li className="breadcrumb-item active" aria-current="page">Notifications</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </div>

            <div className="page-body px-xl-4 px-sm-2 px-0 py-lg-2 py-1 mt-0 mt-lg-3">
                <div className="container-fluid">
                    {/* Notification Stats */}
                    <div className="row g-3 mb-3 row-deck">
                        {notificationStats.map((stat, index) => (
                            <div key={index} className="col-lg-3 col-md-6 col-sm-6">
                                <div className="card">
                                    <div className="card-body">
                                        <i className={`fa ${stat.icon} position-absolute top-0 end-0 mt-4 me-3 text-${stat.color}`} style={{ fontSize: '24px' }}></i>
                                        <div className="mb-2 text-uppercase">{stat.title}</div>
                                        <div><span className="h4">{stat.value}</span></div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>

                    {/* Notifications List */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <div className="card-header">
                                    <h6 className="card-title mb-0">All Notifications</h6>
                                    <div className="dropdown morphing scale-left">
                                        <button className="btn btn-sm btn-outline-secondary">
                                            <i className="fa fa-check-double me-2"></i>Mark All as Read
                                        </button>
                                    </div>
                                </div>
                                <div className="card-body">
                                    <div className="table-responsive">
                                        <DataTable
                                            columns={columns}
                                            data={data}
                                            pagination
                                            highlightOnHover
                                            striped
                                            responsive
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Notifications; 